export default __webpack_public_path__ + "static/media/thumbnail0.2e138311.jpg";